import { connect, type MapDispatchToProps, type MapStateToProps } from 'react-redux';

import { setSelectedSpace, showCreateSpaceDialog } from '../../../state/actions';

import CreateSpaceLink from './create-space-link/connected';
import SpacePicker from './space-picker/connected';
import Content from './index';
import { type OwnProps, type StateProps, type DispatchProps } from './types';
import { type State } from '../../../state/types';
import { type SelectedSpaceData } from '../../../state/ui/connect-space/types';

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = () => ({
	// @ts-ignore - Type '(value: SpacePickerOptionValue, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(value: SpacePickerOptionValue) => void'
	// This was added when enrolling `@atlassiansox/project-pages` into JFE local consumption
	SpacePicker,
	CreateSpaceLink,
});

const dispatch: MapDispatchToProps<DispatchProps, OwnProps> = (dispatch) => ({
	onSpaceSelected: (value: SelectedSpaceData) => dispatch(setSelectedSpace(value)),
	onCreateSpace: () => dispatch(showCreateSpaceDialog()),
});

export default connect<StateProps, DispatchProps, OwnProps, State>(
	mapStateToProps,
	dispatch,
)(Content);
